import axios from "axios";

// Same-origin API base: the platform ingress / nginx always proxies /api to the
// backend, so no absolute URL is baked into the bundle — the app works on any
// domain (apex, www, or preview) without rebuilds.
export const BACKEND_URL = "";
export const API_BASE = "/api";

const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true, // auth travels via httpOnly cookie — no tokens in localStorage
});

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (typeof detail === "object" && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
